// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-dr-placeholder {
  font-size: 12px;
  color: #515151;
}

.analyticscard-dropdown-menu {
  width: 500px;
  height: 440px;
}

@media (min-width: 1024px) {
  .custom-dr-placeholder {
    font-size: 11px;
  }

  .analyticscard-dropdown-menu {
    width: 500px;
    height: 400px;
  }
}
@media (min-width: 1366px) {
  .custom-dr-placeholder {
    font-size: 13px;
  }

  .analyticscard-dropdown-menu {
    width: 500px;
    height: 440px;
  }
}
@media (min-width: 1920px) {
  .custom-dr-placeholder {
    font-size: 13px;
  }

  .analyticscard-dropdown-menu {
    width: 500px;
    height: 440px;
  }
}
.status-interview {
  display: flex;
  align-items: center;
  justify-content: start;
}

.status-selected {
  border: 1px solid #4f86f7;
  background-color: #4f86f7;
  color: white;
  padding: 5px 8px;
  border-radius: 8px;
  margin-left: -8px;
  margin-top: -8px;
  margin-bottom: -8px;
}

.value-selected {
  font-weight: bold;
  color: #fff;
  text-align: center;
}

.status-value {
  font-weight: bold;
  color: #4f86f7;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./../interview/src/components/AnalyticsCard/AnalyticsCard.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;AACF;;AAEA;EACE;IACE,eAAA;EACF;;EAEA;IACE,YAAA;IACA,aAAA;EACF;AACF;AAEA;EACE;IACE,eAAA;EAAF;;EAGA;IACE,YAAA;IACA,aAAA;EAAF;AACF;AAGA;EACE;IACE,eAAA;EADF;;EAIA;IACE,YAAA;IACA,aAAA;EADF;AACF;AAIA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AAFF;;AAKA;EACE,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,WAAA;EACA,kBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;AAFF","sourcesContent":[".custom-dr-placeholder {\n  font-size: 12px;\n  color: #515151;\n}\n\n.analyticscard-dropdown-menu {\n  width: 500px;\n  height: 440px;\n}\n\n@media (min-width: 1024px) {\n  .custom-dr-placeholder {\n    font-size: 11px;\n  }\n\n  .analyticscard-dropdown-menu {\n    width: 500px;\n    height: 400px;\n  }\n}\n\n@media (min-width: 1366px) {\n  .custom-dr-placeholder {\n    font-size: 13px;\n  }\n\n  .analyticscard-dropdown-menu {\n    width: 500px;\n    height: 440px;\n  }\n}\n\n@media (min-width: 1920px) {\n  .custom-dr-placeholder {\n    font-size: 13px;\n  }\n\n  .analyticscard-dropdown-menu {\n    width: 500px;\n    height: 440px;\n  }\n}\n\n.status-interview {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n}\n\n.status-selected {\n  border: 1px solid #4f86f7;\n  background-color: #4f86f7;\n  color: white;\n  padding: 5px 8px;\n  border-radius: 8px;\n  margin-left: -8px;\n  margin-top: -8px;\n  margin-bottom: -8px;\n}\n\n.value-selected {\n  font-weight: bold;\n  color: #fff;\n  text-align: center;\n}\n\n.status-value {\n  font-weight: bold;\n  color: #4f86f7;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
